import { Injectable, Injector } from '@angular/core';
import { BaseResourceService, TransferenciaEspecie } from 'eddydata-lib';

@Injectable({
  providedIn: 'root'
})
export class TransferenciaEspecieService extends BaseResourceService<TransferenciaEspecie> {

  constructor(
    protected injector: Injector
  ) {
    super('transferencia-especies', injector);
  }

}
